import React from "react";
import { Box, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from "@mui/material";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import FolderSpecialRoundedIcon from "@mui/icons-material/FolderSpecialRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import WorkspacesRoundedIcon from "@mui/icons-material/WorkspacesRounded";
import BugReportRoundedIcon from "@mui/icons-material/BugReportRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import { useLocation, useNavigate } from "react-router-dom";

const primary = [
  { value: "/dashboard/owner", label: "Hoy", icon: <DashboardRoundedIcon /> },
  { value: "/dashboard/owner/proyectos", label: "Proyectos", icon: <FolderSpecialRoundedIcon /> },
  { value: "/dashboard/owner/finanzas", label: "Dinero", icon: <AccountBalanceWalletRoundedIcon /> },
  { value: "/dashboard/owner/calendario", label: "Agenda", icon: <CalendarMonthRoundedIcon /> },
  { value: "/dashboard/owner/clientes", label: "Personas", icon: <GroupsRoundedIcon /> },
];

const secondary = [
  { value: "/dashboard/owner/movimientos", label: "Movimientos", icon: <ReceiptLongRoundedIcon fontSize="small" /> },
  { value: "/dashboard/owner/operacion", label: "Operación", icon: <WorkspacesRoundedIcon fontSize="small" /> },
  { value: "/dashboard/owner/estadisticas", label: "Estadísticas", icon: <QueryStatsRoundedIcon fontSize="small" /> },
  { value: "/dashboard/owner/jarvis-lab", label: "Jarvis Lab", icon: <BugReportRoundedIcon fontSize="small" /> },
];

function activePath(pathname) {
  if (pathname.startsWith("/dashboard/owner/jarvis-lab")) return "/dashboard/owner/jarvis-lab";
  if (pathname.startsWith("/dashboard/owner/estadisticas")) return "/dashboard/owner/estadisticas";
  if (pathname.startsWith("/dashboard/owner/movimientos")) return "/dashboard/owner/movimientos";
  if (pathname.startsWith("/dashboard/owner/finanzas")) return "/dashboard/owner/finanzas";
  if (pathname.startsWith("/dashboard/owner/proyectos")) return "/dashboard/owner/proyectos";
  if (pathname.startsWith("/dashboard/owner/calendario")) return "/dashboard/owner/calendario";
  if (pathname.startsWith("/dashboard/owner/clientes")) return "/dashboard/owner/clientes";
  if (pathname.startsWith("/dashboard/owner/operacion")) return "/dashboard/owner/operacion";
  return "/dashboard/owner";
}

export default function OwnerWorkspaceNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const current = activePath(location.pathname);
  const [anchor, setAnchor] = React.useState(null);
  const secondaryActive = secondary.some((item) => item.value === current);

  const go = (path) => { setAnchor(null); navigate(path); };

  return (
    <Box
      component="nav"
      aria-label="Navegación Owner 360"
      sx={{
        width: { xs: 48, sm: 56 },
        flex: "0 0 auto",
        borderRight: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        px: .45,
        py: .6,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: .45,
        overflowY: "auto",
        overscrollBehavior: "contain",
      }}
    >
      {primary.map((tab) => {
        const active = current === tab.value;
        return (
          <Tooltip key={tab.value} title={tab.label} placement="right" arrow enterDelay={250}>
            <IconButton
              type="button"
              aria-label={`Ir a ${tab.label}`}
              aria-current={active ? "page" : undefined}
              onClick={() => go(tab.value)}
              sx={{
                width: { xs: 40, sm: 46 },
                height: { xs: 40, sm: 46 },
                borderRadius: 2.5,
                color: active ? "primary.main" : "text.secondary",
                bgcolor: active ? "rgba(243,90,58,.11)" : "transparent",
                border: active ? "1px solid rgba(243,90,58,.2)" : "1px solid transparent",
                "& svg": { fontSize: { xs: 21, sm: 23 } },
              }}
            >
              {tab.icon}
            </IconButton>
          </Tooltip>
        );
      })}

      <Tooltip title="Más" placement="right" arrow>
        <IconButton
          aria-label="Más secciones"
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ width: { xs: 40, sm: 46 }, height: { xs: 40, sm: 46 }, borderRadius: 2.5, color: secondaryActive ? "primary.main" : "text.secondary", bgcolor: secondaryActive ? "rgba(243,90,58,.11)" : "transparent" }}
        >
          <MoreHorizRoundedIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "bottom", horizontal: "left" }}>
        {secondary.map((item) => (
          <MenuItem key={item.value} selected={current === item.value} onClick={() => go(item.value)} sx={{ minWidth: 180, py: 1 }}>
            <ListItemIcon>{item.icon}</ListItemIcon>{item.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
